import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-loading-insurer-card',
    templateUrl: './loading-insurer-card.component.html',
    styleUrls: ['./loading-insurer-card.component.scss'],
    standalone: false
})
export class LoadingInsurerCardComponent implements OnInit {
  @Input() insurer: any;

  constructor() { }

  ngOnInit(): void {
  }

}
